import styled from "styled-components"

export const TableText = styled.span`
    text-align: left;
    border-right: 1px solid white;
    padding: ${({ theme }) => theme.space.s};
    font-size: ${({ theme }) => theme.font.size.s};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`
export const TableParagraph = styled.p`
    text-align: left;
    border-right: 1px solid white;
    padding: ${({ theme }) => theme.space.s};
    font-size: ${({ theme }) => theme.font.size.s};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`

export const TableRow = styled.div`
    background: ${({ theme }) => theme.color.background.l};
    display: grid;
    grid-template-columns: 20% 30% 10% 40%;
    color: #fefefe;
    border-left: 1px solid white;
    :hover {
        background: rgb(96, 111, 134);
        cursor: pointer;
    }
`

export const HeaderRow = styled.div`
    display: grid;
    grid-template-columns: 20% 30% 10% 40%;
    color: lightgray;
`

export const HeaderText = styled.span`
    text-align: left;
    border-bottom: 1px solid white;
    padding: ${({ theme }) => theme.space.s};
    font-size: ${({ theme }) => theme.font.size.l};
`


// WEBPACK FOOTER //
// ./src/OctoprintParser/RenderTable/styles.js